<template>
  <el-dialog
    :title="$t('CBiBank电子回单')"
    :visible.sync="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    width="720px"
  >
    <div class="payee-list-container">
      <el-form
        ref="receiptForm"
        :model="receiptInfo"
        label-width="110px"
        label-position="left">
        <div class="split-tips">
          {{ $t('请填写邮箱进行申请') + '：' }}
        </div>
        <el-form-item :label="$t('电子邮箱')" prop="email">
          <el-input v-model="receiptInfo.email" :placeholder="$t('请填写准确的邮箱')" type="text" />
        </el-form-item>
        <el-form-item :label="$t('版本')" prop="languageType">
          <el-radio-group v-model="receiptInfo.languageType">
            <el-radio label="EN_CN">{{ $t('中英文') }}</el-radio>
            <el-radio label="EN">{{ $t('English') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="split-tips">
          {{ $t('本次申请下载电子回单如下，请您仔细核对') + '：' }}
        </div>
        <el-form-item :label="$t('账号')">
          <span>{{ searchData.accountNoShow | translateFilter }}</span>
        </el-form-item>
        <el-form-item :label="$t('日期')">
          <span>{{ searchData.startDate || '' }} {{ $t('至') }} {{ searchData.endDate || '' }}</span>
        </el-form-item>
        <el-form-item :label="$t('数量')">
          <span>{{ downloadData.requestNumber || 0 }} {{ $t('条回单') }}，{{ $t('可下载') }} {{ downloadData.realDownloadNumber || 0 }} {{ $t('条') }}</span>
        </el-form-item>
        <div class="tips">
          {{ $t('提示：每张电子回单最多可下载5次，如仍需下载请联系客服') }}
          <span>400-022-9291</span>
        </div>
      </el-form>

      <div class="payee-list-filter-btns">
        <el-button class="search" type="primary" :loading="downloadLoading" @click="download">{{ $t('提交') }}</el-button>
        <el-button class="reset" @click="$emit('cancel')">{{ $t('取消') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import transactionDetailApi from '../api/transactionDetailApi'

export default {
  props: {
    visible: { // 控制显示隐藏
      type: Boolean,
      default: false
    },
    searchFormData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      receiptInfo: {
        email: '', // 电子邮箱
        languageType: 'EN_CN' // 版本
      },
      searchData: {
        accountNoShow: '',
        accountNo: '', // 账户
        loanFlag: 'A', // 账户类型
        currencyType: '', // 币种
        startDate: '', // 开始日
        endDate: '' // 结束日
      },
      downloadData: {}, // 下载数据
      downloadLoading: false
    }
  },
  created () {
    this.init()
  },
  methods: {
    download () {
      if (!this.downloadData.realDownloadNumber || this.downloadData.realDownloadNumber === 0) {
        this.$warn('暂无可下载的数据')
        return false
      }

      this.downloadLoading = true
      transactionDetailApi.batchDownloadConfirm({
        ...this.receiptInfo,
        id: this.downloadData.id
      }).then(res => {
        this.downloadLoading = false
        if (res) {
          this.$success('邮件发送中，稍后请注意查收')
          this.$emit('cancel')
        }
      }).catch(error => {
        this.downloadLoading = false
        console.error(error)
      })
    },
    // 初始化数据
    init () {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = this.searchFormData[key]
      })

      const { accountNo, startDate: startTime, endDate: endTime, loanFlag: transType } = this.searchData
      const accNo = accountNo.split('|')[0]

      transactionDetailApi.preBatchDownload({
        accNo,
        startTime: startTime.split('-').join(''),
        endTime: endTime.split('-').join(''),
        transType
      }).then(res => {
        this.downloadData = res || {}
      }).catch(error => {
        console.error(error)
      })
    },
    // 关闭弹窗回调
    handleClose () {
      this.$refs.receiptForm.resetFields()
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="less">
.payee-list-container .el-form-item{
  display: flex;

  .el-form-item__content {
    flex: 1 1 0%;
    margin-left: 10px !important;
  }
}
</style>
<style lang="less" scoped>
  .confirm-btn {
    min-width: 140px;
  }
  .payee-list-container {
    .split-tips {
      color: #333752;
      margin: 30px 0;
      font-size: 14px;

      &:nth-child(1) {
        font-size: 16px;
        margin-top: 0;
      }
    }

    .tips {
      color: #A1A7C4;
      font-size: 14px;

      span {
        color: #4A6AFF;
      }
    }

    .payee-list-filter-btns {
      margin: 40px 0 30px;
      display: flex;
      justify-content: center;

      .search, .reset {
        min-width: 140px;
      }
    }

    .payee-list-filter {
      display: flex;

      .el-form-item {
        flex: 1 1 0%;

        .el-form-item__content {
          float: left;
        }

        &:nth-child(1) {
          margin-right: 40px;
        }
      }
    }
  }
</style>
